export default __webpack_public_path__ + "2cc39ac5db310abada3566f66a285913.jpg";